import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import ProjectContact from 'src/app/model/company/projectContact';
import Employee from 'src/app/model/product/employee';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { Adjustment } from 'src/app/model/project/adjustment';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'client-adjustment-design-content',
  templateUrl: './client-adjustment-design-content.component.html',
  styleUrls: ['./client-adjustment-design-content.component.scss'],
})
export class ClientAdjustmentDesignContentComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnChanges
{
  @Input()
  projectId: number;

  @Input()
  ipBoard: IPBoard;

  @Input()
  projectContacts: ProjectContact[];

  @Input()
  adjustment: Adjustment;

  @Output()
  save = new EventEmitter<any>();

  designerChoices: Employee[] = [];

  contactName: string;
  contactEmail: string;

  constructor(
    private employeeChoicesService: EmployeeChoicesService,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.calculateFirstProjectContact();
    this.employeeChoicesService.updateDesignerEmployees();
    this.addSubscription(
      this.employeeChoicesService.getDesignerChoicesSubscribable(),
      (designers: Employee[]) => {
        this.designerChoices = designers;
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.projectContacts != null) {
      this.calculateFirstProjectContact();
    }
  }

  extraInfoDesignChanged(value: string): void {
    this.adjustment.extraInfoDesign = value;
    this.save.emit();
  }

  designFollowUpChanged(value: string): void {
    this.adjustment.designFollowUp = value;
  }

  designApprovedChanged(): void {
    if (!this.adjustment.designApproved) {
      this.adjustment.designFinished = false;
    }
    this.save.emit();
  }

  designApprovalFollowupChanged(value: string): void {
    this.adjustment.designApprovalFollowup = value;
    this.save.emit();
  }

  private calculateFirstProjectContact(): void {
    const firstProjectContact = CollectionHelper.isPopulated(
      this.projectContacts
    )
      ? this.projectContacts[0]
      : null;
    if (firstProjectContact == null) {
      this.contactName = null;
      this.contactEmail = null;
    } else {
      this.contactName = firstProjectContact.contact.firstName;
      this.contactEmail = CollectionHelper.isPopulated(
        firstProjectContact.contact.emails
      )
        ? firstProjectContact.contact.emails[0].email
        : null;
    }
  }

  extraDesignAssetsChanged(): void {
    this.projectDisplayObservableService
      .getSubProjectDesignVariableChangedSubscribable()
      .next();
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  goToBord(id: number) {
    this.router.navigateByUrl(`/signs-portal/signs/${id}`);
  }
}
